import { Navigate } from 'react-router-dom';

import { APP_DEFAULT_PATH } from 'config';
import { getDefaultPathForUser, getUser, isAuthenticated } from 'utils/auth';

// Send users to dashboard when logged in, otherwise to login

export default function RootRedirect() {
  if (isAuthenticated()) {
    const user = getUser();
    return <Navigate to={user ? getDefaultPathForUser(user) : APP_DEFAULT_PATH} replace />;
  }

  return <Navigate to="/login" replace />;
}
